class FormValidation {
  public form: HTMLFormElement | null;
  public formSelector: string | null;
  public hasErrors: boolean = false;
  public successCallbackFunction: Function | null = null
  public onErrorCallbackFunction: Function | null = null

  constructor(form: HTMLFormElement | string | null, successCallbackFunction: Function | null = null, onErrorCallbackFunction: Function | null = null) {
    if (typeof form === 'string') {
      this.formSelector = form;
    } else {
      this.form = form;
    }

    this.successCallbackFunction = successCallbackFunction;
    this.onErrorCallbackFunction = onErrorCallbackFunction;
  }

  cache() {
    if (this.formSelector) {
      this.form = document.querySelector(this.formSelector);
    }
  }

  bindings() {
    if (this.form) {
      const submitButtons: NodeListOf<HTMLButtonElement> | null = this.form.querySelectorAll('button[type="submit"]');
      if (submitButtons.length > 0) {
        submitButtons.forEach(submitButton => {
          submitButton.addEventListener('click', (e: Event) => {
            e.preventDefault();

            submitButton.classList.add('is-disabled');

            // reset
            this.hasErrors = false;

            const inputs = this.form?.querySelectorAll('input') as NodeListOf<HTMLInputElement> | null;
            const selects = this.form?.querySelectorAll('select') as NodeListOf<HTMLSelectElement> | null;
            const textareas = this.form?.querySelectorAll('textarea') as NodeListOf<HTMLTextAreaElement> | null;

            inputs?.forEach((input: HTMLInputElement) => {
              this.validate(input);
            });

            selects?.forEach((select: HTMLSelectElement) => {
              this.validate(select);
            });

            textareas?.forEach((textarea: HTMLTextAreaElement) => {
              this.validate(textarea);
            });

            this.prepareNameFields();

            if (!this.hasErrors) {
              if (this.successCallbackFunction != null) {
                this.successCallbackFunction(this.form);
                submitButton.classList.remove('is-disabled');
              } else {
                this.form?.submit();
              }
            } else {
              submitButton.classList.remove('is-disabled');
              if(this.onErrorCallbackFunction != null) {
                this.onErrorCallbackFunction();
              }
              // Dirty solution, sorry not sorry
              // if(this.successCallbackFunction == null) {
                const elPopup = this.form?.closest('.m-popup')
                const elError = this.form?.querySelector('.has-error');

                if (elError && elPopup) {
                  const top = elError.getBoundingClientRect().top + elPopup.scrollTop - 50;
                  elPopup.scrollTo({top});
                  (elError as HTMLElement).focus();
                }
                else if (elError) {
                  const top = elError.getBoundingClientRect().top + window.scrollY - 100;
                  window.scrollTo({top});
                  (elError as HTMLElement).focus();
                }
              // }
            }
          });
        });
      }
    }
  }

  // Firstname + Lastname = FullName // Craft 4 special
  prepareNameFields() {
    // Billing
    const billingFirstNameInput = this.form?.querySelector('[name="billingCustom[firstName]"]') as HTMLInputElement;
    const billingLastNameInput = this.form?.querySelector('[name="billingCustom[lastName]"]') as HTMLInputElement;
    const billingFullNameInput = this.form?.querySelector('[name="billingAddress[fullName]"]') as HTMLInputElement;
    if (billingFirstNameInput && billingLastNameInput && billingFullNameInput) {
      if (billingFirstNameInput.value != "" && billingLastNameInput.value != "") {
        billingFullNameInput.value = billingFirstNameInput.value + ' ' + billingLastNameInput.value;
      }
    }

    // Shipping
    const shippingFirstNameInput = this.form?.querySelector('[name="shippingCustom[firstName]"]') as HTMLInputElement;
    const shippingLastNameInput = this.form?.querySelector('[name="shippingCustom[lastName]"]') as HTMLInputElement;
    const shippingFullNameInput = this.form?.querySelector('[name="shippingAddress[fullName]"]') as HTMLInputElement;
    if (shippingFirstNameInput && shippingLastNameInput && shippingFullNameInput) {
      if (shippingFirstNameInput.value != "" && shippingLastNameInput.value != "") {
        shippingFullNameInput.value = shippingFirstNameInput.value + ' ' + shippingLastNameInput.value;
      }
    }

    // Generic
    const firstNameInput = this.form?.querySelector('[name="firstName"]') as HTMLInputElement;
    const lastNameInput = this.form?.querySelector('[name="lastName"]') as HTMLInputElement;
    const fullNameInput = this.form?.querySelector('[name="fullName"]') as HTMLInputElement;
    if (firstNameInput && lastNameInput && fullNameInput) {
      if (firstNameInput.value != "" && lastNameInput.value != "") {
        fullNameInput.value = firstNameInput.value + ' ' + lastNameInput.value;
      }
    }

  }

  validate(input: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement) {
    const shouldValidate = this.shouldValidate(input);
    if (shouldValidate) {
      // @ts-ignore
      let inputValue = "";
      if (['checkbox', 'radio'].includes(input.type)) {
        // @ts-ignore
        inputValue = input.checked;
      } else if (['select-one'].includes(input.type)) {
        // @ts-ignore
        inputValue = input.selectedOptions[0].value;
      } else {
        inputValue = input.value;
      }

      if (!inputValue && (input as HTMLInputElement).minLength === -1) {
        if ((input as HTMLInputElement).pattern) {
        } else {
          this.handleInputErrorDecoration(input);
          this.hasErrors = true;
        }
      } else if(!inputValue && input.type === 'select-one'){
        this.handleInputErrorDecoration(input);
        this.hasErrors = true;
      } else {
        if (input.type === 'email') {
          const isEmailValid = this.validateEmail(input.value);

          if (!isEmailValid) {
            this.handleInputErrorDecoration(input, 'E-Mail-Adresse ist ungültig');
            this.hasErrors = true;
          }
        } else if ((input as HTMLInputElement).minLength !== -1 && !(input as HTMLInputElement).pattern) {
          if (input.value.length < (input as HTMLInputElement).minLength) {
            this.handleInputErrorDecoration(input, 'Eingabe ist zu kurz');
            this.hasErrors = true;
          }
        } else if ((input as HTMLInputElement).pattern) {
          if (!input.validity.valid) {
            if (input.type == 'password') {
              this.handleInputErrorDecoration(input, 'Passwort ist zu kurz (min. 6 Zeichen)');
            }
            else {
              this.handleInputErrorDecoration(input, 'USt-ID ist ungültig');
            }

            this.hasErrors = true;
          }
        }
      }
    }
  }

  validateEmail(email: string) {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email);
  }

  handleInputErrorDecoration(input: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement, errorMessage: string = '') {
    if (!input.classList.contains('has-error')) {
      input.classList.add('has-error');
      const errorMessageDiv = document.createElement('div');
      errorMessageDiv.classList.add('error-message');
      errorMessageDiv.innerText = errorMessage ? errorMessage : input.dataset.errorMessage ?? '* Pflichtfeld';

      input.parentElement?.appendChild(errorMessageDiv);

      const eventListenerType = ['checkbox', 'radio', 'select', 'select-one'].includes(input.type) ? 'change' : 'keyup';

      input.addEventListener(eventListenerType, () => {
        // @ts-ignore
        if ((input.value && input.minLength === -1) || (input.value && input.minLength !== -1 && input.value.length >= input.minLength) || input.checked || (!input.value && !input.required)) {
          input.classList.remove('has-error');
          errorMessageDiv.classList.add('is-hidden');
        } else {
          input.classList.add('has-error');
          errorMessageDiv.classList.remove('is-hidden');
        }
      });
    }
  }

  shouldValidate(input: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement) {
    const { dependedOn, reverseDependencyCheck } = input.dataset;

    if (input.required && dependedOn) {
      const dependencyInput = document.querySelector(`input[name="${dependedOn}"]`) as HTMLInputElement;

      const dependencyInputValue = dependencyInput.type === 'checkbox' ? dependencyInput.checked : dependencyInput.value;

      if (dependencyInput && (dependencyInputValue !== reverseDependencyCheck)) {
        return true;
      }

      return false;
    }

    return input.required || (input as HTMLInputElement).pattern;
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default FormValidation;
